'use client';

import Link from '@eliadmin/core/src/components/link';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { LuArrowLeft, LuX } from 'react-icons/lu';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { useRouter } from 'next/navigation';

export function SecondaryHeader({ isProfile, isCart }: { isProfile: boolean; isCart: boolean }) {
  const isDesktop = useBreakpoint('sm');
  const { t } = useTranslations();
  const router = useRouter();

  // This header only renders on the profile root and the cart, so linking "Zpět" to
  // ROUTES.PROFILE()/ROUTES.CART() pointed at the current page. Cart steps push history entries,
  // so going back also walks the checkout steps; a direct visit falls back to the homepage.
  const handleBack = () => {
    if (window.history.length > 1) router.back();
    else router.push(ROUTES.HOME());
  };

  return (
    <header
      className={cn('custom-section', 'border-b-broder border-b bg-white py-4 sm:py-5 lg:py-6')}
    >
      <div className={cn('custom-container', 'flex items-center justify-between gap-4')}>
        <div className="flex w-full flex-1 items-center justify-start">
          <Button
            type="button"
            variant={'none'}
            className="flex items-center justify-center text-walnut"
            size={'none'}
            onClick={handleBack}
            aria-label={t('text1026')}
          >
            <LuArrowLeft size={20} aria-hidden />
            <p className="hidden sm:block">{t('text1026')}</p>
          </Button>
        </div>
        <Heading
          tag={isDesktop ? 'h2' : 'h3'}
          center
          title={isProfile ? t('text197') : t('text3414')}
        />
        <div className="flex w-full flex-1 items-center justify-end">
          <Button
            asChild
            variant={'none'}
            className="flex items-center justify-center text-walnut"
            size={'none'}
          >
            <Link prefetch={false} href={ROUTES.HOME()} aria-label={t('text3703')}>
              <LuX size={20} aria-hidden />
              <p className="hidden sm:block">{t('text3703')}</p>
            </Link>
          </Button>
        </div>
      </div>
    </header>
  );
}
